import React from "react";
import {inject, observer} from 'mobx-react';
import * as mobx from 'mobx';
import {Button, Menu, Dropdown, Icon, Select, Modal} from "antd";
import {WeaInputSearch, WeaSelect, WeaBrowser} from "ecCom";
import {WeaLocaleProvider} from 'ecCom'
const getLabel = WeaLocaleProvider.getLabel
import SearchFavourite from "../../util/SearchFavourite";
import BrowserDict from "../../constants/BrowserDict";

const confirm = Modal.confirm;
const listBtns = BrowserDict.listBtns;

@observer
export default class SysFavouriteBar extends React.Component {

    /**
     * “添加”下拉按钮的点击事件
     * @param evt
     */
    handleMenuClick = evt => {
        this.setState({
            favType: evt.key
        });
    }

    /**
     * 下拉框点击选项的事件
     * @param value
     */
    handleTypeChange = value => {
        let {sysFavouriteStore} = this.props;
        sysFavouriteStore.setFavouriteType(value);
    }

    /**
     * 搜索的事件
     * @param value
     */
    handleOnSearch = value => {
        let {sysFavouriteStore} = this.props;
        let {favtype} = sysFavouriteStore;
        SearchFavourite.setConditions({pagename: value, favtype});
        let isinit = true;
        let isreload = false;
        let searchFavourite = new SearchFavourite(sysFavouriteStore);
        let params = {isinit, isreload};
        searchFavourite.load(params);
    }

    /**
     * 删除操作
     */
    handleOnDelete = () => {
        let {sysFavouriteStore} = this.props;
        let {selectedIds} = sysFavouriteStore;
        confirm({
            content: `${getLabel(388216, "删除后不可恢复，您确认删除选中的记录吗？")}`,
            onOk() {
                sysFavouriteStore.deleteFavourite(selectedIds.join());
            },
            onCancel() {
            }
        });
    }

    /**
     * 移动操作
     */
    handleOnMove = () => {
        let {sysFavouriteStore, favouriteDialogStore, favouriteBrowserStore} = this.props;
        let {selectedIds} = sysFavouriteStore;
        selectedIds = mobx.toJS(selectedIds);
        //设置需要移动的数据
        sysFavouriteStore.setMoveIds(selectedIds);
        //先清空数据
        favouriteBrowserStore.destroyBrowser();
        //显示窗口
        favouriteDialogStore.openBrowserDialog();
        //显示加载中的遮罩
        favouriteBrowserStore.toggleSpinning(true, `${getLabel(82275, "数据加载中，请稍候...")}`);
        //加载目录树的数据
        favouriteBrowserStore.loadTreedata("0");
    }

    handleBrowserChange = (ids, names, datas) => {
        let {favType} = this.state;
        let {sysFavouriteStore, favouriteDirStore} = this.props;
        let {selectedKey} = favouriteDirStore;
        let tempids = [];
        let tempnames = [];
        datas.forEach(item => {
            let {id, name} = item;
            tempids.push(id);
            tempnames.push(name);
        });

        sysFavouriteStore.addSysFavourites(tempids, selectedKey, tempnames, favType);
    }


    /**
     * 添加按钮的下拉菜单
     * @returns {XML}
     */
    renderMenu = () => {
        let addBtnList = mobx.toJS(this.props.addBtnList);
        let menuItems = addBtnList.map(item => {
                let browserParams = listBtns[item.id];
                return (
                    <Menu.Item key={item.id} className="sysfav-bar-item">
                        <WeaBrowser {...browserParams} onChange={this.handleBrowserChange}
                                    className="sysfav-bar-item-browser">
                            {item.name}
                        </WeaBrowser>
                    </Menu.Item>
                );
            }
        );
        return (
            <Menu onClick={this.handleMenuClick}>{menuItems}</Menu>
        );
    }

    /**
     *  收藏类型的下拉框
     * @returns {*}
     */
    renderOpts = () => {
        let typeList = mobx.toJS(this.props.typeList);
        let options = typeList.map(item => {
            let obj = {};
            obj.key = item.id;
            obj.showname = item.name;
            return obj;
        });
        return options;
    }

    /**
     * 移动、删除按钮
     * @returns {Array}
     */
    renderBtns = () => {
        let {myFavouriteStore, sysFavouriteStore} = this.props;
        let {moveBtnName, deleteBtnName} = myFavouriteStore;
        let {selectedIds} = sysFavouriteStore;
        let btns = [];
        if (selectedIds.length > 0) {
            btns.push(<Button type="primary" onClick={this.handleOnMove}>{moveBtnName}</Button>);
            btns.push(<Button type="primary" style={{"margin-left": "15px"}}
                              onClick={this.handleOnDelete}>{deleteBtnName}</Button>);
        } else {
            btns.push(<Button type="primary" disabled="disabled">{moveBtnName}</Button>);
            btns.push(<Button type="primary" disabled="disabled"
                              style={{"margin-left": "15px"}}>{deleteBtnName}</Button>);
        }
        return btns;
    }

    render() {
        const menu = this.renderMenu();
        const opts = this.renderOpts();
        const btns = this.renderBtns();
        const {favtype, myFavouriteStore} = this.props;
        let {addBtnName} = myFavouriteStore;

        return (
            <div className="sysfav-top-bar">
                <div className="sysfav-top-bar-common sysfav-top-bar-left">
                    <Dropdown overlay={menu}>
                        <Button>
                            <Icon type="plus"/>{addBtnName}
                        </Button>
                    </Dropdown>

                    <WeaSelect options={opts} value={favtype}
                               onChange={this.handleTypeChange}>
                    </WeaSelect>

                    <WeaInputSearch onSearch={this.handleOnSearch}/>
                </div>

                <div className="sysfav-top-bar-common sysfav-top-bar-right">
                    {btns}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/favourite/SysFavouriteBar.js